module.exports = __webpack_public_path__ + "img/certificado.76ef52c9.webp";